import React, { useState } from "react";
import { notification } from "antd";
import { apiRequest } from "util/services";
import Representation from './Representation';
import i18n from 'i18next';

const Modal = ({ user, showModal, setShowModal, getSubscribtionStatus }) => {
  const [apiKey, setApiKey] = useState("");
  const [apiSecret, setApiSecret] = useState("");

  const onSubmit = async () => {
    const payload = {
      firebase_id: user.uid,
      twitter_api_key: apiKey,
      twitter_api_secret: apiSecret
    }
    const result = await apiRequest("users/add_twitter_keys", "POST", payload, true);
    if (result && !result.error) {
      notification.success({
        message: i18n.t("notifications.114"),
      });
      getSubscribtionStatus();
    } else {
      notification.error({ message: result.error });
    }
    setShowModal(false);
  }

  return <Representation
    setApiSecret={setApiSecret}
    setApiKey={setApiKey}
    onSubmit={onSubmit}
    showModal={showModal}
    setShowModal={setShowModal}
  />
}

export default Modal;